import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/auth'

interface FeatureFlagsResponse {
  toggles: any[]
}

export const useFeatureFlagsStore = defineStore('featureFlags', {
  state: () => ({
    isFetched: false,
    flags: {
      toggles: [] as any[]
    }
  }),
  actions: {
    setFeatureFlags(flags: any) {
      if (Array.isArray(flags)) {
        this.flags.toggles = flags
      } else {
        this.flags = flags
      }
    },
    async fetchFeatureFlags() {
      const authStore = useAuthStore()
      const userId = authStore.userId

      const data = await $fetch<FeatureFlagsResponse>('/api/feature-flags', {
        query: userId ? { userId } : undefined
      })

      this.setFeatureFlags(data.toggles)
      this.isFetched = true

      return data
    }
  }
})
